import baseScmService from 'services/baseScmService';
import { RECORDING_REQUEST_STATUSES } from '../data/recordingRequestStatuses';

const recordingRequestService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getPendingRequests: build.query({
      query: () => ({
        url: '/recording-requests',
        params: {
          status: RECORDING_REQUEST_STATUSES.pending,
        },
      }),
      providesTags: (result, error) => {
        return error ? [] : [{ type: 'RecordingRequest' }];
      },
    }),
    updateRecordingRequest: build.mutation({
      query: ({ id, note, action }) => ({
        url: `/recording-requests/${id}`,
        method: 'PUT',
        body: {
          recording_request: {
            status: action,
          },
          note,
        },
      }),
      invalidatesTags: (result, error) =>
        error ? [] : [{ type: 'RecordingRequest' }],
    }),
  }),
});

export const { useGetPendingRequestsQuery, useUpdateRecordingRequestMutation } =
  recordingRequestService;

export default recordingRequestService;
